import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import Table from "../../components/Table/Table";
import classes from "./Support.module.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import AlertDialog from "../../components/ui/AlertDialog/AlertDialog";
import InputField from "../../components/ui/InputField/InputField";
import axios from "axios";
import { env } from "../../constants/env"; // assuming your API base URL is here
import { toast } from "react-toastify";

const Support = () => {
  const [tickets, setTickets] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showTableDialog, setShowTableDialog] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const limit = 10;

  const columns = [
    // { key: "id", label: "ID" },
    { key: "name", label: "NAME" },
    { key: "title", label: "TITLE" },
    { key: "status", label: "STATUS" },
  ];

  const fetchTickets = async (page, search) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${env.apiUrl}/api/tickets`, {
        params: { page, limit, search },
      });
      setTickets(res.data.tickets);
      setPageCount(res.data.totalPages);
    } catch (err) {
      setError("Failed to load tickets.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page on new search
  };

  const handleDeleteTicket = async (ticketIndex) => {
    if (!tickets[ticketIndex]) return;

    const ticketId = tickets[ticketIndex].id;
    const token = localStorage.getItem("adminToken");

    try {
      await axios.delete(`${env.apiUrl}/api/tickets/${ticketId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Remove ticket from state
      setTickets((prev) => prev.filter((_, i) => i !== ticketIndex));
      setShowTableDialog(false);
      toast.success("successfully deleted ticket");
    } catch (err) {
      console.error("Error deleting ticket:", err);
      toast.error("Failed to delete ticket");
    }
  };

  const handleCloseTicket = async (ticketIndex) => {

    if (!tickets[ticketIndex]) return;

    const ticketId = tickets[ticketIndex].id;
    const token = localStorage.getItem("adminToken");

    try {
      const res = await axios.patch(
        `${env.apiUrl}/api/tickets/${ticketId}/close`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Update ticket status in state
      setTickets((prev) =>
        prev.map((ticket, i) =>
          i === ticketIndex
            ? { ...ticket, status: res.data.ticket.status }
            : ticket
        )
      );
      setShowTableDialog(false);
      toast.success("successfully closed ticket");
    } catch (err) {
      console.error("Error closing ticket:", err);
      toast.error("Failed to close ticket");
    }
  };

  return (
    <div className={classes.wrapper}>
      <InputField
        className="mb-3"
        search
        placeholder="Search tickets"
        inputContainerClass={classes.inputContainer}
        value={searchQuery}
        onChange={handleSearchChange}
      />

      {loading && <p>Loading tickets...</p>}
      {error && <p className="text-danger">{error}</p>}

      {!loading && !error && (
        <Table
          dataType={"Support"}
          data={tickets}
          columns={columns}
          showDialog={showTableDialog}
          setShowDialog={setShowTableDialog}
          ticketInfo={() => setShowDialog(true)}
          clickedIndex={(index) => setSelectedTicket(index)}
          deleteTicket={() => handleDeleteTicket(selectedTicket)}
          editTicket={() => handleCloseTicket(selectedTicket)}
        />
      )}

      <AlertDialog
        isOpen={showDialog}
        toggleSidebar={() => setShowDialog(false)}
        onClose={() => setShowDialog(false)}
        titleText="View ticket"
        showCloseIcon
        style={{ left: `calc(50vw - 250px)`, width: 500 }}
      >
        {selectedTicket !== null && tickets[selectedTicket] ? (
          <div className={`d-flex flex-column gap-3 ${classes.containerBox}`}>
            <InputField
              labelText="Title"
              value={tickets[selectedTicket].title}
              disabled
            />
            <InputField
              labelText="Details"
              value={tickets[selectedTicket].details}
              disabled
              isTextarea
            />
          </div>
        ) : (
          <p>No ticket selected</p>
        )}
      </AlertDialog>

      <div className="mt-4">
        <ReactPaginate
          previousLabel={
            <FaChevronLeft
              color={
                currentPage === 1
                  ? "var(--border-default)"
                  : "var(--text-secondary-color)"
              }
            />
          }
          nextLabel={
            <FaChevronRight
              color={
                currentPage === pageCount || pageCount === 0
                  ? "var(--border-default)"
                  : "var(--text-secondary-color)"
              }
            />
          }
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={1}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          previousLinkClassName={`page-link ${
            currentPage === 1 ? "disabled" : ""
          }`}
          nextLinkClassName={`page-link ${
            currentPage === pageCount || pageCount === 0 ? "disabled" : ""
          }`}
          activeClassName={"active"}
        />
      </div>
    </div>
  );
};

export default Support;
